import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { DAILY_QUOTES } from "@/data/quotes";
import { logError } from "@/lib/log";

export const QuoteCard = () => {
  const [quote] = useState(() => DAILY_QUOTES[Math.floor(Math.random() * DAILY_QUOTES.length)]);
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/quotes/saved").then((r) => setSaved(r.data.some((q) => q.text === quote.text))).catch((e) => logError("Saved quotes failed:", e));
  }, [quote]);

  const toggle = async () => {
    setBusy(true);
    try {
      if (saved) await api.post("/quotes/saved/remove", { text: quote.text });
      else await api.post("/quotes/saved", quote);
      setSaved(!saved);
      toast.success(saved ? "Removed from saved" : "Saved to your quotes 💜");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="mm-gradient rounded-3xl p-6 mb-6 mm-fade-up" data-testid="home-quote">
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs uppercase tracking-wider opacity-80 font-semibold">Quote of the day</div>
        <button onClick={toggle} disabled={busy} aria-label={saved ? "Remove from saved quotes" : "Save quote"} aria-pressed={saved}
          className="p-2 -m-2 rounded-full hover:bg-white/15 transition-transform active:scale-90" data-testid="home-quote-save">
          <Heart size={20} fill={saved ? "currentColor" : "none"} />
        </button>
      </div>
      <p className="font-display text-lg sm:text-xl mt-2 leading-snug" data-testid="home-quote-text">“{quote.text}”</p>
      <div className="flex items-center justify-between gap-2 mt-2">
        <div className="text-sm opacity-80">— {quote.author}</div>
        <Link to="/saved-quotes" className="text-xs font-semibold rounded-full bg-white/20 hover:bg-white/30 px-3 py-1 transition-colors" data-testid="home-quote-saved-link">Saved quotes</Link>
      </div>
    </div>
  );
};
